import { render, staticRenderFns } from "./FileManager.vue?vue&type=template&id=060da984&"
import script from "./FileManager.vue?vue&type=script&lang=js&"
export * from "./FileManager.vue?vue&type=script&lang=js&"
import style0 from "./FileManager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports